<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><span><i>To my friends and saviors</i></span></p>
<p class="center1"><span><i>Linda and Randy Siebels</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0b0f1b68